<div [class]="['plan-card', 'flex-column', (isDoubleColumnCard ? 'double-column' : 'single-column')]">
  <div class="plan-card-header flex-column">
    <div [class]="['app-name-and-number', 'flex-row', getHeaderClass()]">
      <div>{{ plan.applicantLastName ? (plan.applicantLastName + ', ' + plan.applicantFirstName) : '' }}</div>
      <div class="margin-left-auto">{{ plan.applicationTrackingId }}</div>
    @if(showAppTypeIndicator){
      <div class="app-type-indicator">{{ appType }}</div>
    }
    </div>
    @if(showReviewStatusBar){
      <div [class]="['review-status', getReviewStatusBarClass(), 'flex-row']">
        {{ reviewStatus || 'Submitted'}} <!-- TODO: change to RetailAppService reference when service is updated-->
      </div>
    }
  </div>

  <div [class]="['plan-details', 'flex-column', (isDoubleColumnCard ? 'double-column' : 'single-column')]">
    <div class='plan-name-container flex-column'>
      <div class='data-label'> Plan Name </div>
      <div class="plan-name">{{ plan.productName }}</div>
    </div>

    <hr class="plan-name-separator">

    <div [class]="{
      'app-details-container': true,
      'double-column': isDoubleColumnCard,
      'flex-row': isDoubleColumnCard,
      'single-column': !isDoubleColumnCard,
      'three-column-grid': !isDoubleColumnCard
    }">
      @if(!hideAppStatus){
        <div class="status-info flex-column">
            <div class='detail-item flex-row'>
              <div class="data-label"> Status: </div>
              <div [class]="['app-status', getStatusClass()]">{{ appStatus }}</div>
            </div>
            @if (plan.statusDescription && plan.statusDescription != 'null') {
              <div class='detail-item flex-row'>
                <div class="data-label"> Reason: </div>
                <div class="data-value">{{ plan.statusDescription }}</div>
              </div>
            }
        </div>
      }
      @if(!isDoubleColumnCard){
        <div class="label-container flex-column single-column">
          <div class='data-label'> Creation Date: </div>
          <div class='data-label'> Submission Date: </div>
          <div class='data-label'> Effective Date: </div>
        </div>
        <div class="value-container single-column flex-column">
          <div class="data-value">{{ plan.creationDate | date:'MMM dd, y'}}</div>
          @if (isSubmittedApp) {
            <div class="data-value">{{plan.applicationLastModified | date:'MMM dd, y'}}</div>
          } @else {
            <div>N/A</div>
          }
          @if (plan.effectiveDate) {
            <div class="data-value">{{plan.effectiveDate | date:'MMM dd, y'}}</div>
          }
          @if (!plan.effectiveDate) {
            <div>N/A</div>
          }
        </div>
        <div class='view-app single-column flex-row'>
          @if (showApplicationButton && !isLoading) {
            <button (click)="retrieveApp()" type="button" mat-raised-button
            color="primary" class="primary-btn">{{ linkDesc }}</button>
          }
          @if (isLoading) {
            <mat-spinner class="retrieve-app-spinner" [diameter]="25"></mat-spinner>
          }
        </div>
      }@else{
        <div [class]="['date-container', 'flex-column', (isDoubleColumnCard ? 'double-column' : 'single-column')]">
          <div class='detail-item double-column flex-row'>
            <div class="label-container"><span class='data-label'> Created: </span></div>
            <div class="value-container double-column">
              <span class="data-value">{{ plan.creationDate | date:'MMM d, y'}}</span>
            </div>
          </div>
        @if (showSubmitDate) {
          <div class="detail-item double-column flex-row">
            <div class="label-container"><span class='data-label'> Submitted: </span></div>
            <div class="value-container double-column">
              @if (isSubmittedApp) {
                <span class="data-value">{{plan.applicationLastModified | date:'MMM d, y'}}</span>
              }
              @if (!isSubmittedApp) {
                <span>N/A</span>
              }
            </div>
          </div>
        }
        @if (showEffectiveDate) {
          <div class= 'detail-item double-column flex-row'>
            <div class="label-container"><span class='data-label'> Effective Date: </span></div>
            <div class="value-container">
              @if (plan.effectiveDate) {
                <span class="data-value">{{plan.effectiveDate | date:'MMM d, y'}}</span>
              }
              @if (!plan.effectiveDate) {
                <span>N/A</span>
              }
            </div>
          </div>
        }
      </div>
      }
    </div>

    @if(!hideAppStatus || typeLabel){
      <div class='footer-container flex-row'>
        @if (typeLabel) {
          <div class='type-label'>
            <span class='data-label'>{{ typeLabel }}</span>
          </div>
        }
        <div class='view-app double-column margin-left-auto'>
          @if (showApplicationButton && !isLoading) {
            <button (click)="retrieveApp()" type="button" mat-raised-button
            color="primary" class="primary-btn">{{ linkDesc }}</button>
          }
          @if (isLoading) {
            <mat-spinner class="retrieve-app-spinner" [diameter]="25"></mat-spinner>
          }
        </div>
      </div>
    }
  </div>
</div>

